import {
  ResponseTypeEnum,
  TemplateNodeSchema,
} from '@ulysses-inc/harami_api_client'
import { Alert, Flex, Select, Typography } from 'antd'
import Modal from 'antd/es/modal/Modal'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useQueryTraceKeysByResponseType } from 'src/features/traceKeys/api/useQueryTraceKeys'
import {
  selectAvailableTraceKeys,
  selectRemainingTraceKeysCount,
  useChangeTraceKey,
} from 'src/state/ducks/templates/selectors'

import { RootState } from 'src/state/store'
const { Text } = Typography
const { Option } = Select

type Props = {
  onClose: () => void
  questionNode: TemplateNodeSchema
}
export const EditTraceKeyModal = ({ onClose, questionNode }: Props) => {
  const { data: traceKeys = [] } = useQueryTraceKeysByResponseType(
    questionNode.question?.responseType,
  )

  const availableTraceKeys = useSelector((state: RootState) =>
    selectAvailableTraceKeys(traceKeys)(state),
  )

  const [selectedTraceKey, setSelectedTraceKey] = useState<
    | {
        id: number
      }
    | undefined
  >(undefined)

  const { changeTraceKey } = useChangeTraceKey()

  const onOk = () => {
    if (!selectedTraceKey) {
      return
    }
    changeTraceKey(questionNode, selectedTraceKey.id)

    onClose()
  }

  const onChange = (value: number) => {
    setSelectedTraceKey({ id: value })
  }

  const remainingTraceKeysCount = useSelector((state: RootState) =>
    selectRemainingTraceKeysCount(state),
  )

  const isLimitReached = remainingTraceKeysCount <= 0

  return (
    <Modal
      title="検索キーに紐付ける"
      open={true}
      destroyOnClose={true}
      onCancel={onClose}
      onOk={onOk}
      okButtonProps={{
        disabled: isLimitReached || !selectedTraceKey,
      }}
      okText="保存"
      cancelText="キャンセル"
      centered
      width={480}
      styles={{
        body: {
          paddingTop: 12,
          paddingBottom: 20,
        },
        footer: {
          marginTop: 0,
        },
      }}
    >
      <Flex vertical gap={4}>
        <Text strong>検索キーの種類</Text>
        {isLimitReached ? (
          <Alert
            description="このひな形で検索キーを設定できる質問の上限に達しています。他の質問の検索キーを外してから設定してください。"
            type="error"
            showIcon
            style={{ fontSize: 14 }}
          />
        ) : (
          <>
            <Select placeholder="検索キーを選択" onChange={onChange}>
              {availableTraceKeys.map(traceKey => (
                <Option key={traceKey.id} value={traceKey.id}>
                  {traceKey.name}
                </Option>
              ))}
            </Select>
            <Text type="secondary" style={{ fontSize: 14 }}>
              このひな形では残り{remainingTraceKeysCount}
              件の質問に検索キーを設定できます。
            </Text>
          </>
        )}
        <Text type="secondary" style={{ fontSize: 14 }}>
          「このセクションを繰り返す」の中の質問には設定できません。
          {questionNode.question?.responseType ===
            ResponseTypeEnum.RESPONSE_SET && (
            <>
              <br />
              <Alert
                description="検索キーに紐付けると、選択できる回答数は1件のみとなります。"
                type="warning"
                showIcon
                style={{
                  marginTop: 16,
                  fontSize: 16,
                }}
              />
            </>
          )}
        </Text>
      </Flex>
    </Modal>
  )
}
